// import { GUIOverlay } from '@game-libs/gui-overlay';
import { Loader } from 'excalibur';

export class GameLoader extends Loader {
  // closeOverlay: () => void;

  constructor() {
    super();

    // const { openOverlay } = GUIOverlay();

    // this.closeOverlay = openOverlay(
    //   <div className={'game-start-screen'}>
    //     <img src={'./loader/avtg-logo.webp'} />
    //   </div>
    // );

    // this.startButtonFactory = () => {
    //   let myButton = document.createElement('button');
    //   myButton.textContent = "Let's go!";
    //   myButton.classList.add('play-button');

    //   myButton.addEventListener('click', () => {
    //     this.closeOverlay();
    //   });

    //   return myButton;
    // };

    this.backgroundColor = '#111111';
  }
}
